import React from "react";

const RateTemplateIcon = (props:any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.005 7L11.45 1.37C11.6143 1.26036 11.8075 1.20185 12.005 1.20185C12.2026 1.20185 12.3957 1.26036 12.56 1.37L21.005 7V21C21.005 21.2652 20.8996 21.5196 20.7121 21.7071C20.5246 21.8946 20.2702 22 20.005 22H4.005C3.73979 22 3.48543 21.8946 3.2979 21.7071C3.11036 21.5196 3.005 21.2652 3.005 21V7ZM5.005 8.07V20H19.005V8.07L12.005 3.403L5.005 8.07Z"
          fill={props?.color ?? "black"}
        />
        <path
          d="M15 16V12C15 11.45 14.55 11 14 11H10V9H15V7H12.5V6H10.5V7H9C8.45 7 8 7.45 8 8V12C8 12.55 8.45 13 9 13H13V15H8V17H10.5V18H12.5V17H14C14.55 17 15 16.55 15 16Z"
          fill={props?.color ?? "black"}
        />
      </svg>
    </div>
  );
};

export default RateTemplateIcon;
